import { DatabaseIcon, FileSpreadsheetIcon, FileTextIcon, NewspaperIcon } from "lucide-react";
import { getSeq } from "../../../../../helpers/get-seq";
import { Card, CardContent } from "../../../utils/landing-page/card";
import "./index.scss";

export function PerformanceSection() {
  const performanceStats = [
    {
      icon: <FileTextIcon className="PerformanceSection-icon" />,
      count: "+10000",
      label: "Enregistrements",
      borderClass: "blueBorder",
    },
    {
      icon: <DatabaseIcon className="PerformanceSection-icon" />,
      count: "05",
      label: "Référentiels",
      borderClass: "greenBorder",
    },
    {
      icon: <FileSpreadsheetIcon className="PerformanceSection-icon" />,
      count: "50",
      label: "Structures connectées",
      borderClass: "purpleBorder",
    },
    {
      icon: <NewspaperIcon className="PerformanceSection-icon" />,
      count: "60",
      label: "Utilisateurs actifs",
      borderClass: "orangeBorder",
    },
  ];

  const connectedStructures = [
    {
      count: "20",
      label: "Ministères",
      bgClass: "greenGradient",
      textClass: "greenText",
    },
    {
      count: "4",
      label: "Agence",
      bgClass: "pinkGradient",
      textClass: "pinkText",
    },
    {
      count: "26",
      label: "Direction générale & technique",
      bgClass: "blueGradient",
      textClass: "blueText",
    },
  ];

  return (
    <section id="solution" className="PerformanceSection">
      <div className="PerformanceSection-backgroundEffects">
        <div className="PerformanceSection-blueEffect" />
        <div
          className="PerformanceSection-greenEffect"
          style={{ animationDelay: "2s" }}
        />
      </div>

      <div className="PerformanceSection-container">
        <div className="PerformanceSection-mainContent">
          <div className="PerformanceSection-statsSection">
            <div className="PerformanceSection-header">
              <h2 className="PerformanceSection-title">
                Statistiques
              </h2>
              <p className="PerformanceSection-description">
                Des chiffres qui témoignent de l&#39;efficacité de notre plateforme de gestion des
                référentiels et de la coordination inter-administrative au Bénin.
              </p>
            </div>

            <div className="PerformanceSection-statsGrid">
              {performanceStats.map((stat, index) => (
                <div
                  key={`stat-${getSeq()}-${index}`}
                  className={`PerformanceSection-statCard ${stat.borderClass}`}
                >
                  <Card transparent className="PerformanceSection-statCardContent">
                    <CardContent className="PerformanceSection-statCardContent">
                      <div className="PerformanceSection-iconContainer">
                        {stat.icon}
                      </div>
                      <div className="PerformanceSection-statText">
                        <p className="PerformanceSection-count">
                          {stat.count}
                        </p>
                        <p className="PerformanceSection-label">
                          {stat.label}
                        </p>
                      </div>
                    </CardContent>
                  </Card>
                </div>
              ))}
            </div>
          </div>

          <div>
            <Card className="PerformanceSection-structuresCard">
              <CardContent className="PerformanceSection-structuresContent">
                <div className="PerformanceSection-structuresHeader">
                  <h2 className="PerformanceSection-structuresTitle">
                    Structures Administratives Connectées
                  </h2>
                </div>

                <div className="PerformanceSection-structuresGrid">
                  {connectedStructures.map((structure, index) => (
                    <div
                      key={`structure--${getSeq()}-${index}`}
                      className={`PerformanceSection-structureItem ${structure.bgClass}`}
                    >
                      <p className={`PerformanceSection-structureCount ${structure.textClass}`}>
                        {structure.count}
                      </p>
                      <p className="PerformanceSection-structureLabel">
                        {structure.label}
                      </p>
                    </div>
                  ))}
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
}
